import { useEffect } from 'react';
import { useUtility } from '../utilityReactProvider';
export var useUserProfileMethods = function () {
    var UserProfile = useUtility().UserProfile;
    useEffect(function () {
        if (!UserProfile) {
            throw new Error('The Utility provided does not include UserProfile module, ensure you are using the right version');
        }
    }, []);
    return {
        getUserProfile: UserProfile === null || UserProfile === void 0 ? void 0 : UserProfile.getUserProfile,
        getActiveUserProfile: UserProfile === null || UserProfile === void 0 ? void 0 : UserProfile.getActiveUserProfile,
        clearUserProfile: UserProfile === null || UserProfile === void 0 ? void 0 : UserProfile.clearUserProfile,
        updateUserProfile: UserProfile === null || UserProfile === void 0 ? void 0 : UserProfile.updateUserProfile,
    };
};
